import { Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import AmortizationSchedule from './components/AmortizationSchedule';
import ExportDialog from './components/ExportDialog';
import Graph from './components/Graph';
import Params from './components/Params';
import Summary from './components/Summary';
import { calculateAmortization } from './helpers/calculateAmortization';

const CreditSimulator = (props: any) => {
  const {
    creditDetails,
    setCreditDetails,
    amortizationSchedule,
    setAmortizationSchedule,
    editing,
    documents,
    selectedRequest,
    setDocumentsToApply,
    selectedDocuments: propSelectedDocuments,
    setSelectedDocuments: propSetSelectedDocuments,
    executivesPortfolio,
    executivesAll,
  } = props;
  const [workingDayActive, setWorkingDayActive] = useState<
    'active' | 'inactive'
  >('inactive');
  const [resultView, setResultView] = useState('summary');
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [localSelectedDocuments, setLocalSelectedDocuments] = useState<
    string[]
  >([]);

  const selectedDocuments = propSelectedDocuments || localSelectedDocuments;
  const setSelectedDocuments =
    propSetSelectedDocuments || setLocalSelectedDocuments;

  useEffect(() => {
    calculateAmortization({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
    });
  }, [
    creditDetails.amount,
    creditDetails.operationCost,
    creditDetails.otherExpenses,
    creditDetails.firstPaymentDate,
    creditDetails.rate,
    creditDetails.interestType,
    creditDetails.operationDate,
    creditDetails.periodicity,
    creditDetails.months,
    creditDetails.notary,
    creditDetails.taxes,
    workingDayActive,
  ]);

  const handleExportSimulation = () => {
    console.log('amortizationSchedule', amortizationSchedule);
    setOpenExportDialog(true);
  };

  useEffect(() => {
    calculateAmortization({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
      documents,
    });
  }, []);

  useEffect(() => {
    if (creditDetails.documentsToApply) {
      setSelectedDocuments(
        creditDetails.documentsToApply.map((doc: any) => doc.documentId) || [],
      );
    }
  }, []);

  return (
    <div>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: 'background.paper',
          mb: 2,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {editing
              ? 'Ingresa los parámetros del crédito'
              : 'Estos son los datos del crédito'}
          </Typography>
          {editing && (
            <Typography
              onClick={() => handleExportSimulation()}
              variant="caption"
              color="primary"
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              Exportar
            </Typography>
          )}
        </div>

        <Params
          selectedRequest={selectedRequest}
          setDocumentsToApply={setDocumentsToApply}
          documentsToApply={creditDetails.documentsToApply}
          selectedDocuments={selectedDocuments}
          setSelectedDocuments={setSelectedDocuments}
          creditDetails={creditDetails}
          setCreditDetails={setCreditDetails}
          editing={editing}
          workingDayActive={workingDayActive}
          setWorkingDayActive={setWorkingDayActive}
          executivesPortfolio={executivesPortfolio}
          executivesAll={executivesAll}
        />
      </Paper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          content: 'center',
        }}
      >
        <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
          Resultados de la simulación |{' '}
          <span style={{ color: 'grey' }}>Descargar</span>
        </Typography>
        <div style={{ display: 'flex', gap: 10 }}>
          {resultView !== 'summary' && (
            <Typography
              sx={{ cursor: 'pointer', fontWeight: 'bold', color: 'blue' }}
              variant="body1"
              onClick={() => setResultView('summary')}
            >
              Ver resumen
            </Typography>
          )}
          {resultView !== 'cuotas' && (
            <Typography
              sx={{ cursor: 'pointer', fontWeight: 'bold', color: 'blue' }}
              variant="body1"
              onClick={() => setResultView('cuotas')}
            >
              Ver cuotas
            </Typography>
          )}
          {resultView !== 'graph' && (
            <Typography
              sx={{ cursor: 'pointer', fontWeight: 'bold', color: 'blue' }}
              variant="body1"
              onClick={() => setResultView('graph')}
            >
              Ver gráfico
            </Typography>
          )}
        </div>
      </div>
      {resultView === 'summary' && (
        <Summary
          creditDetails={creditDetails}
          amortizationSchedule={amortizationSchedule}
        />
      )}
      {resultView === 'graph' && (
        <Graph amortizationSchedule={amortizationSchedule} />
      )}
      {resultView === 'cuotas' && (
        <AmortizationSchedule amortizationSchedule={amortizationSchedule} />
      )}
      {openExportDialog && (
        <ExportDialog
          open={openExportDialog}
          setOpen={setOpenExportDialog}
          creditDetails={creditDetails}
          amortizationSchedule={amortizationSchedule}
        />
      )}
    </div>
  );
};

export default CreditSimulator;
